import React from 'react'
import { Button, Popup, Message } from 'semantic-ui-react'
import AcceptModal from '../../Modals/AcceptModal'
import DeclineModal from '../../Modals/DeclineModal'
import ReferralModal from '../../Modals/ReferralModal'

const Pending = ({ project, job }) => {
  const isOnHold =
    project.type === 'Interview' &&
    project.team.creditBalance - project.numUpcomingMeetings <= 0

  return (
    <>
      {isOnHold ? (
        <Message warning size="tiny">
          This project is currently on hold, so please check back later. We
          apologize for any inconvenience.
        </Message>
      ) : (
        <div className="ui two buttons">
          <AcceptModal project={project} job={job}>
            <Button basic color="green">
              Accept
            </Button>
          </AcceptModal>
          <DeclineModal project={project}>
            <Button basic color="red">
              Decline
            </Button>
          </DeclineModal>
        </div>
      )}
      {project.referable && (
        <Popup
          content="Share this project"
          position="top left"
          trigger={
            <ReferralModal project={project}>
              <Button
                circular
                size="small"
                style={{
                  float: 'right',
                  marginTop: '10px',
                }}
                icon="paper plane"
              />
            </ReferralModal>
          }
        />
      )}
    </>
  )
}

export default Pending
